import { memo } from "react";
import { Box } from "@mui/material";

function ErroIcon({ ...other }) {
  return (
    <Box {...other}>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.73894 1.96367C8.79394 1.86875 8.89363 1.8125 9.00019 1.8125C9.10676 1.8125 9.20644 1.86875 9.26145 1.96367L16.078 13.4141C16.1261 13.4949 16.1502 13.5863 16.1502 13.6777C16.1502 13.959 15.9268 14.1875 15.6518 14.1875H2.34863C2.07363 14.1875 1.8502 13.959 1.8502 13.6777C1.8502 13.5828 1.87426 13.4914 1.92238 13.4141L8.73894 1.96367ZM7.32957 1.08477L0.513008 12.5352C0.306758 12.8797 0.200195 13.2734 0.200195 13.6777C0.200195 14.8906 1.1627 15.875 2.34863 15.875H15.6518C16.8377 15.875 17.8002 14.8906 17.8002 13.6777C17.8002 13.2734 17.6902 12.8797 17.4874 12.5352L10.6708 1.08477C10.3168 0.490625 9.68426 0.125 9.00019 0.125C8.31613 0.125 7.68363 0.490625 7.32957 1.08477ZM10.1002 11.9375C10.1002 11.6391 9.9843 11.353 9.77801 11.142C9.57172 10.931 9.29193 10.8125 9.00019 10.8125C8.70846 10.8125 8.42867 10.931 8.22238 11.142C8.01609 11.353 7.90019 11.6391 7.90019 11.9375C7.90019 12.2359 8.01609 12.522 8.22238 12.733C8.42867 12.944 8.70846 13.0625 9.00019 13.0625C9.29193 13.0625 9.57172 12.944 9.77801 12.733C9.9843 12.522 10.1002 12.2359 10.1002 11.9375ZM9.82519 5.46875C9.82519 5.00117 9.45738 4.625 9.00019 4.625C8.54301 4.625 8.17519 5.00117 8.17519 5.46875V8.84375C8.17519 9.31133 8.54301 9.6875 9.00019 9.6875C9.45738 9.6875 9.82519 9.31133 9.82519 8.84375V5.46875Z"
          fill="#A80000"
        />
      </svg>
    </Box>
  );
}

export default memo(ErroIcon);
